import {
  Description,
  DialogActions,
  DialogContent,
  ElementsArea,
  Flex,
  Popup,
  FlatButton,
  IconButton,
  Icon,
  Link,
  IPopupProps,
} from "@evergis/ui";
import { Props as TippyProps } from "tippy.js";
import styled from "styled-components";
import { DialogTitle } from "../DialogComponents/styled";

export const InputRow = styled(Flex)`
  padding-bottom: 0.5rem;
  justify-content: space-between;
`;

export const MultiEditTitle = styled(DialogTitle)`
  padding-left: 3.5rem;
  padding-top: 2.5rem;
  width: 44rem;
`;

export const MultiEditText = styled(Description)`
  && {
    color: ${({ theme: { palette } }) => palette.textSecondary} !important;
  }

  margin: 0;
`;

export const ModeEditorToggleTitle = styled(Description)<{ fontSize?: string; maxWidth?: string }>`
  && {
    padding-top: 0.25rem;
    padding-bottom: 0.5rem;
    font-size: ${({ fontSize }) => `${fontSize}`};
    max-width: ${({ maxWidth }) => `${maxWidth}`};
    color: ${({ theme: { palette } }) => palette.primary} !important;
  }

  cursor: pointer;
  margin: 0;
`;

export const ActionsContainer = styled(DialogActions)`
  padding-top: 2.5rem;
`;

export const CalculationBlockContainer = styled(DialogContent)`
  display: flex;
  flex-direction: column;
`;

export const TemplatesContainer = styled(ElementsArea)`
  width: 100%;
  margin-top: 1.5rem;
  flex-direction: column;
  height: 7.875rem;
  display: flex;
`;

export const TemplateLabelContainer = styled(Flex)<{ width?: string }>`
  margin-left: 1rem;
  background-color: ${({ theme: { palette } }) => palette.background};
  padding: 0.75rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  max-width: 10rem;
  height: 3rem;
  cursor: pointer;
  width: ${({ width }) => `${width || "10rem"}`};
  align-items: center;

  &:hover {
    box-shadow: ${({ theme: { shadows } }) => shadows.normal};
  }
`;

export const TemplateIcon = styled.div<{ img: string }>`
  height: 3rem;
  width: 3rem;
  background: ${({ img }) => `url(${img}) center center no-repeat`};
`;

export const TemplateLabelText = styled(Description)`
  padding-left: 0.75rem;
  max-width: 3.625rem;
  margin: 0;
`;

export const TemplatesTitle = styled(Description)`
  margin-left: 3.5rem;
`;

export const TemplateFormContainer = styled.div`
  width: 18rem;
  padding: 1rem 1rem 0.5rem 1rem;
`;

export const TemplateActionButtons = styled(Flex)`
  justify-content: space-between;
  padding-top: 1.25rem;
`;

export const PopupWithCustomBlank = styled(Popup)<Partial<IPopupProps & TippyProps>>`
  position: absolute;
  transform: translate(-0.125rem, -98%);

  @media screen and (max-width: 992px) {
    & {
      max-width: initial;
    }
  }
`;

export const PopupMenu = styled(Popup)``;

export const ButtonRow = styled(Flex)`
  padding-top: 1rem;
  justify-content: space-between;
`;

export const ButtonBlock = styled(Flex)`
  justify-content: space-between;
`;

export const AdvancedFunctionButton = styled(FlatButton)<{ width: string }>`
  background-color: rgba(0, 0, 0, 0.06);
  box-shadow: none;
  min-width: ${({ width }) => `${width} !important`};
  font-weight: 500;
  min-height: 2rem;
  padding: 0;
  text-align: center;

  :not(:last-child) {
    margin-right: 0.5rem;
  }
`;

export const AdvancedActionButton = styled(IconButton)`
  background-color: rgba(0, 0, 0, 0.06);
  width: 2rem;

  :not(:last-child) {
    margin-right: 0.5rem;
  }

  &:active {
    background-color: ${({ theme: { flatButton } }) => flatButton.activeBackgroundColor};
  }

  &:active > ${Icon} {
    transform: scale(1);
  }
`;

export const AdditionalInfoLink = styled(Link).attrs(() => ({ target: "_blank" }))`
  padding-top: 0.5rem;
  font-size: 0.75rem;
  color: ${({ theme: { palette } }) => palette.primary} !important;
`;

export const MenuListWrapper = styled.div`
  height: 14.625rem;
`;
